const ROUTE_PATHS = {
  ORDER_PREMIUM_BANNER: '/orderpremiumbanner',
  CUSTOMER_INFO: '/customerinfo',
  LANDING_COUPON_HERO: '/landingcouponhero',
  PDP_LOYALTY_TOUCHPOINT: '/pdppremiumbanner',
  ACCOUNT_LOYALTY_TOUCHPOINT: '/accountpremiumbanner',
  PDP_CANCEL_DEMAND_MODAL: '/pdpcanceldemandmodal',
  PDP_SUSPEND_MODAL: '/pdpsuspendmodal',
  PREMIUM_ONE_CLICK: '/premiumoneclick',
  BASKET_TOUCHPOINT: '/baskettouchpoint',
  LOYALTY_TOUCHPOINT: '/loyaltytouchpoint',
  ORDER_TOUCHPOINT: '/ordertouchpoint',
  ORDER_SUCCESS_TOUCHPOINT: '/ordersuccesstouchpoint',
  ORDER_DETAIL_TOUCHPOINT: '/orderdetailtouchpoint',
  SOLUTION_CENTER_TOUCHPOINT: '/solutioncentertouchpoint',
  SOLUTION_CENTER_CANCEL: '/solutioncenterpremiumcancel',
  ACCOUNT_SIDEBAR_TOUCHPOINT: '/accountsidebartouchpoint',
  HOMEPAGE_TOUCHPOINT: '/homepagetouchpoint',
  HOMEPAGE_TOUCHPOINT_V2: '/homepagetouchpointV2',
  LOYALTY_DETAIL_TOUCHPOINT: '/loyaltydetailtouchpoint'
};

export default ROUTE_PATHS;
